import type { ReactNode } from 'react';

import { brandGlyph, useBranding } from '../lib/branding';

import { AppearanceControl } from './Appearance';
import { SlotBrandMark } from './BrandMark';
import { Skeleton } from './Primitives';

/**
 * The split panel from the sign-in design of record: a brand half rendered entirely from
 * configuration (R2) and a content half. Every surface outside the admin chrome — sign in,
 * the must-change wall, the signed-in home, refusals — wears it, so the app reads as one
 * product before and after a session exists.
 */
export function BrandPanel({ children }: { children: ReactNode }) {
  const branding = useBranding();
  const data = branding.data;

  const glyph = data === undefined ? '' : brandGlyph(data);
  const tagline = data?.tagline.trim() ?? '';
  const taglineSub = data?.taglineSub.trim() ?? '';

  return (
    <>
      <main>
        <div className="b-grid">
          <aside className="b-brand">
            <div className="brand-row">
              <SlotBrandMark logoUrl={data?.logoUrl ?? null} glyph={glyph} />
              {data === undefined ? (
                <Skeleton style={{ height: 12, width: 120, borderRadius: 5 }} />
              ) : (
                <span className="brand-name">{data.name}</span>
              )}
            </div>
            {tagline === '' ? null : <p className="b-line">{tagline}</p>}
            {taglineSub === '' ? null : <p className="b-sub">{taglineSub}</p>}
            <div className="b-glyph" aria-hidden="true">
              {glyph}
            </div>
          </aside>
          <div className="b-main">
            <div className="b-col">{children}</div>
          </div>
        </div>
      </main>
      {/* The fixed corner is FURNITURE — placement only. The control inside it is the same
          one the admin rail and the account menu render, at the same size. */}
      <div className="theme">
        <AppearanceControl />
      </div>
    </>
  );
}
